import React from 'react';

import {
    HTMLRequestSender,
    EvgenSender,
    CompositeSender,
    FilmoscopeAdapter,
} from '@kinopoisk-int/ott-player-tracker';
import { PlayerTrackerWithPluggableSender } from '@kinopoisk-int/ott-player-tracker/dist/lib/PlayerTrackerWithPluggableSender';

export interface PlayerTrackerContextValue {
    tracker: null | PlayerTrackerWithPluggableSender<FilmoscopeAdapter>;
    sender:
        | {
              type: 'composite';
              htmlRequest: HTMLRequestSender;
              evgen: EvgenSender;
              composite: CompositeSender;
          }
        | { type: 'old'; htmlRequest: HTMLRequestSender }
        | null;
}

export const PlayerTrackerContext = React.createContext<PlayerTrackerContextValue>({
    tracker: null,
    sender: null,
});
